var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.image && _vm.image.url)?_c('div',{staticClass:"image-container",class:_vm.alignment},[_c('AzImg',{class:`image-container__img ${_vm.size}`,attrs:{"src":_vm.image.url,"alt":_vm.image.alt,"size":_vm.dimensions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }